import * as React from 'react';
const VaginiteIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M106.2 110.56c0-4.73 3.26-9.34 5.57-13.46 1.8-3.22 2.86-7.19 2.86-11.5 0-10.71-6.55-15.23-14.63-15.23S85.37 74.89 85.37 85.6c0 4.27 1.05 8.22 2.81 11.42 2.3 4.16 5.62 8.8 5.61 13.55M62.33 87.2c-2.15 0-4.19-2.74-4.19-6.12h0c.13-3.92 3.68-8.48 11.87-7.89s16.6 3.51 16.6 3.51"
      className="prefix__cls-2"
    />
    <ellipse
      cx={69.2}
      cy={86.72}
      className="prefix__cls-2"
      rx={6.87}
      ry={5.72}
    />
    <path
      d="M137.67 87.2c2.15 0 4.19-2.74 4.19-6.12h0c-.13-3.92-3.68-8.48-11.87-7.89s-16.6 3.51-16.6 3.51"
      className="prefix__cls-2"
    />
    <ellipse
      cx={130.8}
      cy={86.72}
      className="prefix__cls-2"
      rx={6.87}
      ry={5.72}
    />
    <path d="M93.78 90.26s1.04 4.71 3.9 7.17" className="prefix__cls-2" />
    <circle cx={100} cy={134.28} r={8.66} className="prefix__cls-1" />
    <circle cx={100} cy={134.28} r={1.24} className="prefix__cls-1" />
    <circle cx={100} cy={134.28} r={16.14} className="prefix__cls-1" />
  </svg>
);
export default VaginiteIcon;
